import * as React from 'react';

import './Milestone.scss';

export interface MilestoneProps {
    text: string;
    price: number;
    divided: string;
}

class Milestone extends React.Component<MilestoneProps> {
    render () {
        const { text, price, divided} = this.props;

        return (
            <div className="milestone-wrap">
                <span className="milestone-wrap__title">{text}</span>
                <p className="milestone-wrap__text-wrap">
                    <span className="milestone-wrap__text info-text">{price} €</span> / <span className="milestone-wrap__text info-text">{divided}</span>
                </p>

            </div>
        );
    }
}

export default Milestone;